export default (self, pagination = {}, f, column = {}) => {
  let getData, filters;

  if (Array.isArray(self)) {
    getData = self[1];
    filters = self[2];
    self = self[0];
  }

  if (!getData) {
    getData = 'getData';
  }

  if (!filters) {
    filters = 'active_filters';
  }

  if (!getData || !self[getData] || typeof self[getData] !== 'function') {
    return false;
  }

  let sharedFilters = filters && self.state[filters] ? { ...self.state[filters] } : {};

  for (let key in sharedFilters) {
    const val = sharedFilters[key];
    if (Array.isArray(val)) {
      sharedFilters[key] = val;
    } else if (typeof val === 'object' && val !== null) {
      sharedFilters[key] = { ...val };
    } else {
      sharedFilters[key] = val != null ? val.toString() : val;
    }
  }

  sharedFilters.sort = column.order === 'descend' ? '-' : '';
  sharedFilters.page = pagination.current;
  sharedFilters.sort += column.field || '';

  self[getData](sharedFilters);
};
